"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCategory = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var ErrorCategory;
(function (ErrorCategory) {
    ErrorCategory["Internal"] = "internal";
    ErrorCategory["External"] = "external";
    ErrorCategory["Unhandled"] = "unhandled";
})(ErrorCategory = exports.ErrorCategory || (exports.ErrorCategory = {}));
//# sourceMappingURL=types.js.map